import moment from "moment"
import { apiGet, apiPost, apiDelete, apiPut, API_URI } from "api"

const calendar = {
  getAll: async (clientId: number, dateFrom: Date, dateTo: Date) => {
    const data = await apiGet(`${API_URI}/api/calendar?clientId=${clientId}&dateFrom=${moment(dateFrom).format("DD MMM YYYY")}&dateTo=${moment(dateTo).format("DD MMM YYYY")}`)
    return data
  },
  getAllForBoard: async (clientId:number, boardId: number, dateFrom: Date, dateTo: Date) => {
    const data = await apiGet(`${API_URI}/api/calendar/board?clientId=${clientId}&boardId=${boardId}&dateFrom=${moment(dateFrom).format("DD MMM YYYY")}&dateTo=${moment(dateTo).format("DD MMM YYYY")}`)
    return data
  },
  event: {
    get: async (id: number) => {
      const data = await apiGet(`${API_URI}/api/calendar/event/${id}`);
      return data;
    },
    getAll: async (clientId: number, dateFrom: Date, dateTo: Date) => {
      const data = await apiGet(`${API_URI}/api/calendar/event?clientId=${clientId}&dateFrom=${moment(dateFrom).format("DD MMM YYYY")}&dateTo=${moment(dateTo).format("DD MMM YYYY")}`)
      return data
    },
    add: async (clientId: number, title: string, description: string, dueDate: Date, isShared: boolean) => {
      const data = await apiPost(`${API_URI}/api/calendar/event`,  { 
        ClientId: clientId, 
        Title: title, 
        Description: description, 
        DueDate: moment(dueDate).format("DD MMM YYYY"), 
        IsShared: isShared})
      return data
    },
    delete: async (id: number) => {
      const data = await apiDelete(`${API_URI}/api/calendar/event/${id}`)
      return data
    },
    update: async (id: number, title: string, description: string, dueDate: string, shared: boolean) => {
      const data = await apiPut(`${API_URI}/api/calendar/event/${id}`, {
        Title: title,
        Description: description,
        DueDate: dueDate,
        IsShared: shared
      })
      return data
    },
  },
}

export default calendar
